import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => {
  return {
    containerContentDialog: {
      display: "flex",
      flexDirection: "column",
      gap: "16px",
    },
    containerFiledItem: {
      display: "flex",
      flexDirection: "row",
      gap: "16px 32px",
    },
    containerAttatcmentFiled: {
      display: "flex",
      flexDirection: "column",
      gap: "16px",
      width: "100%",
    },
    titleFiled: {
      minWidth: "160px",
      maxWidth: "280px",
    },
    uploadedFilesContainer: {
      display: "flex",
      flexDirection: "column",
      gap: "12px",
      marginTop: "12px",
    },
    uploadedFileCard: {
      display: "flex",
      flexDirection: "row",
      padding: "16px",
      gap: "12px",
    },
    uploadedFileDetailsContainer: {
      display: "flex",
      flexDirection: "column",
      width: "100%",
    },
    fileHeaderContainer: {
      position: "relative",
    },
    fileNameText: {
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      maxWidth: "330px",
      display: "inline-block",
      fontSize: "14px",
      fontWeight: "500",
      lineHeight: "20px",
      color: theme.palette.text.secondary,
    },
    DeleteIcon: {
      cursor: "pointer",
      position: "absolute",
      right: "0px",
      top: "0px",
    },
    fileSizeText: {
      fontSize: "14px",
      fontWeight: "400",
      lineHeight: "20px",
      color: theme.palette.text.tertiary,
    },
    MoreUploadContainer: {
      display: "flex",
      flexDirection: "column",
      margin: "0px 0px 16px 0px",
    },
    HeaderTableSection: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      backgroundColor: theme.palette.background.hover,
      padding: "12px 24px",
    },
    TitleItemTable: {
      fontSize: "14px",
      fontWeight: "600",
      lineHeight: "20px",
      color: theme.palette.text.tertiary,
    },
    BodyTableSection: {
      display: "flex",
      flexDirection: "column",
    },
    rowMoreUpload: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      padding: "16px 24px",
      borderBottom: `1px solid ${theme.palette.utility.utility_gray_200}`,
    },
    categoryName: {
      width: "130px",
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "20px",
      color: theme.palette.text.tertiary,
    },
    containerFile_Name: {
      display: "flex",
      flexDirection: "row",
      gap: "12px",
      alignItems: "center",
    },
    fileName: {
      width: "184px",
      fontSize: "14px",
      fontWeight: 500,
      lineHeight: "20px",
      color: theme.palette.text.primary,
      overflow: "hidden",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
    },
  };
});
